import React from 'react';
import './AlertSteps.css';

/**
 * What this alert does now, opening an edit (PRD-1382).
 *
 * **The server's sentence, not ours.** The wizard holds the stored IR and could
 * render its own description of it — and that is exactly the second renderer
 * this epic keeps arguing against. `alert_summary` comes from `describe_alert`,
 * the same function the Activity Log writes its before-and-after lines with, so
 * the opener and the record cannot say different things about one document.
 *
 * A conversation that describes an alert differently from its own log is the
 * hardest kind of disagreement to notice, because each reads correctly alone.
 *
 * Absent rather than empty when there is nothing to say: an alert whose spec
 * predates this field, or a create flow that never had one, gets no box at all
 * rather than a heading over blank space.
 */
const AlertEditOpener = ({ summary = [] }) => {
  const lines = Array.isArray(summary) ? summary.filter(Boolean) : [];
  if (lines.length === 0) return null;

  return (
    <div className="alert-edit-opener">
      <p className="alert-edit-opener-label">This alert currently watches for</p>
      <ul className="alert-edit-opener-lines">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      <p className="alert-edit-opener-prompt">
        Change the threshold below, or describe what should be different.
      </p>
    </div>
  );
};

export default AlertEditOpener;
